export const YANDEX_AD_SLOT_VERTICAL = "R-A-424060-1";
export const YANDEX_AD_SLOT_HORIZONTAL = "R-A-424060-2";